// Client-side unguessable public id for a locally-created card. Base62 from a
// CSPRNG, mirroring internal/shortid on the server (unguessable, not sequential
// or derived). Used so the NFC/QR/share URL encodes https://<origin>/<publicId>.
//
// NOTE: this makes the tag URL well-formed; for that URL to RESOLVE when tapped,
// the card still needs to be published server-side (a separate step) — a
// local-only card returns the generic 404.
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

/** A random Base62 public id (default 10 chars, ~59 bits). */
export function newPublicId(len = 10): string {
  const rnd = new Uint32Array(len);
  crypto.getRandomValues(rnd);
  let out = '';
  for (let i = 0; i < len; i++) out += ALPHABET[rnd[i] % ALPHABET.length];
  return out;
}
